<template>
    <v-dialog max-width="500px" v-model="inDialog" persistent>
        <v-card>
            <v-form ref="viewPresentForm">
                <div class="headline dialog-header">
                    <v-toolbar color="primary" dark>
                        <v-toolbar-title style="padding-left: 10px">{{
                            $t(formCreateName)
                        }}</v-toolbar-title>
                    </v-toolbar>
                    <v-btn
                        @click="onCancel"
                        icon
                        style="
                            position: absolute;
                            right: 10px;
                            top: 10px;
                            color: #fff;
                        "
                    >
                        <v-icon>cancel</v-icon>
                    </v-btn>
                </div>
                <v-card-text>
                    <v-layout wrap>
                        <v-flex xs12>
                            <v-select
                                :items="areas"
                                :label="$t('Khu nuôi')"
                                v-model="item.areaId"
                                name="areaId"
                                item-value="categoryId"
                                item-text="categoryCode"
                                v-validate="'required'"
                                :data-vv-as="$t('Khu nuôi')"
                                :error-messages="errors.first('areaId')"
                                :disabled="item.pondId ? true : false"
                                v-on:change="areaChange(item.areaId)"
                            />
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="pondType"
                                :label="$t('Loại ao')"
                                v-model="item.type"
                                name="type"
                                item-value="categoryId"
                                item-text="categoryName"
                                v-validate="'required'"
                                :data-vv-as="$t('Loại ao')"
                                :error-messages="errors.first('type')"
                                v-on:change="pondTypeChange(item.type)"
                                :disabled="item.pondId ? true : false"
                            />
                        </v-flex>
                        <!-- <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Tên ao')"
                                v-model.trim="item.name"
                                name="name"
                                maxLength="250"
                                v-validate="'required'"
                                :error-messages="errors.first('name')"
                                :data-vv-as="$t('Tên ao')"
                            ></v-text-field>
                        </v-flex> -->
                        <v-flex xs12>
                            <v-text-field
                                type="text"
                                :label="$t('Mã ao')"
                                v-model.trim="item.code"
                                name="code"
                                v-validate="'required'"
                                maxLength="250"
                                :error-messages="errors.first('code')"
                                :data-vv-as="$t('Mã ao')"
                                disabled
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-select
                                :items="pondStatus"
                                :label="$t('Trạng thái')"
                                v-model="item.status"
                                name="status"
                                item-value="value"
                                item-text="text"
                                v-validate="'required'"
                                :data-vv-as="$t('Trạng thái')"
                                :error-messages="errors.first('status')"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{ $t("lang.common.save") }}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{ $t("lang.common.cancel") }}
                </v-btn>
            </div>
        </v-card>
    </v-dialog>
</template>

<script>
import { message } from "../../../services";
import axios from "axios";
import { cateContants } from "@/constants";
import moment from "moment";

export default {
    name: "pond-create",
    components: { message, axios },
    props: {
        propsItem: {
            type: Object,
            default: () => {
                    return {}
                }
        },
        cDialog: {
            type: Boolean,
            default: false,
        },
        formCreateName: {
            type: String,
            default: '',
        },
        pondType: {
            type: Array,
            default: [],
        },
        areas: {
            type: Array,
            default: [],
        },
        hiddenFields: {
            type: Object,
            default: () => {
                return {}
            }
        }
    },
    data: () => {
        return {
            formName: "Cập nhật đối tượng",
            showStartDate: false,
            showEndDate: false,
            pondStatus: cateContants.pondStatus,
            type: 0,
            step: 1,
            max_seed_Number: false,
            inDialog: false,
            item: {
                areaId: '',
                code: "",
                name: "",
                // parentId: 0,
                // pondId: 0,
                // procedureId: 0,
                // seed_Number: 0,
                // startDate: "",
                // endDate: "",
                status: 0,
                type: '',
                userId: '',
                currentNo: 0,
            },
        };
    },
    watch: {
        propsItem: {
            handler(value) {
                console.log(value);
                if (value !== null) {
                    this.step = 2;
                    this.item = {
                        areaId: value.areaId ? value.areaId : 0,
                        code: value.code ? value.code : "",
                        name: value.name ? value.name : "",
                        // parentId: value.parentId ? value.parentId : 0,
                        pondId: value.pondId,
                        // procedureId: value.procedureId ? value.procedureId : 0,
                        // seed_Number: value.seed_Number ? value.seed_Number : "",
                        // startDate: moment(String(value.startDate)).format(
                        //     "YYYY-MM-DD"
                        // ),
                        // endDate: moment(String(value.endDate)).format(
                        //     "YYYY-MM-DD"
                        // ),
                        status: value.status ? value.status : 0,
                        type: value.type ? value.type : "",
                        // userId: value.userId ? value.userId : 0,
                        currentNo: value.currentNo ? value.currentNo : 0,
                        currentYear: value.currentYear
                    };
                } else {
                    this.step = 1;
                    this.resetFrom();
                }
            },
            deep: true,
        },
        cDialog(value) {
            this.inDialog = value;
        },
        inDialog (value) {
            if(!value){
                this.$emit("closeCreateDialog", "");
            }
        },
        hiddenFields(value) {
            this.item.type = value.type ? value.type : '';
        },
    },
    methods: {
        resetFrom: function () {
            this.item = {
                areaId: '',
                code: "",
                name: "",
                // parentId: 0,
                // pondId: 0,
                // procedureId: 0,
                // seed_Number: 0,
                // startDate: "",
                // endDate: "",
                status: 0,
                type: this.hiddenFields.type ? this.hiddenFields.type : '',
                userId: '',
                currentNo: 0,
            };
        },
        onContinue: function () {
            if (this.item.type !== "") {
                this.step = 2;
            } else {
                message.error(this.$t("Bạn chưa chọn loại ao"));
            }
        },
        onCancel: function () {
            this.step = 1;
            this.$emit("closeCreateDialog", "");
        },
        onSave: function () {
            // console.log(this.item);
            this.$validator.validate().then((valid) => {
                if (!valid) {
                    message.error(this.$t("lang.common.validate_fail"));
                    return;
                }
                axios
                    .post(process.env.VUE_APP_API_URL + "/pond/save", this.item)
                    .then(
                        (data) => {
                            console.log(data);
                            if (data.success) {
                                message.success(
                                    this.$t("lang.common.save_success")
                                );
                                this.resetFrom();
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        },
                        (error) => {
                            console.log(error);
                        }
                    );
            });
        },
        onChangeParent(event) {
            const self = this;
            this.parents.find((o) => {
                if (o.pondId === event) {
                    self.item.seed_Number = o.seed_Number;
                    self.max_seed_Number = o.seed_Number;
                }
            });
        },
        areaChange(areaId) {
            this.getNextCode();
        },
        pondTypeChange(type) {
            this.getNextCode();
        },
        getNextCode: function () {
            let areaCode = "";
            for(let i=0; i < this.areas.length; i++){
                if(this.areas[i].categoryId == this.item.areaId){
                    if (this.areas[i].parentName != null && this.areas[i].parentName != '') {
                        areaCode = this.areas[i].parentName
                    } else {
                        areaCode = this.areas[i].categoryCode
                        areaCode = areaCode.replace("KHU", "");
                    }
                    break;
                }
            }

            let typeCode = "N";
            for(let i=0; i < this.pondType.length; i++){
                if(this.pondType[i].categoryId == this.item.type){
                    if (this.pondType[i].parentName != null && this.pondType[i].parentName != '') {
                        typeCode = this.pondType[i].parentName
                    } else {
                        let typeName = this.pondType[i].categoryName
                        typeName = typeName.toUpperCase();
                        let str = typeName.replace("AO ", "");
                        typeCode = str.split(/\s/).reduce((response,word)=> response+=word.slice(0,1),'');
                    }
                    break;
                }
            }
            console.log(typeCode);
            if(areaCode != ""){
                areaCode = areaCode + typeCode;
                areaCode = areaCode.toUpperCase();
                axios.get(
                    process.env.VUE_APP_API_URL +
                    "/autoIncrease/getNextCode?type=POND_" + areaCode + "&prefix="+areaCode+"&numberZeroBeforeCodeNumberCode=1&suffix="
                ).then((data) => {
                        this.item = Object.assign({}, this.item, {"code": data})
                    });
            }
        },
    },
    created() {},
};
</script>
